import Vue from 'vue'

import ProxyDevice from './devices/Proxy.js'

import UnknownDevice from './devices/Unknown.js'
import VideonEncoder from './devices/VideonEncoder.js'
import VideonDecoder from './devices/VideonDecoder.js'

var EncoderProductNames = ['', 'edgecaster', 'edgecaster_max']
var DecoderProductNames = ['example_device', 'bd_sdi_decoder']

export default new class VideonDevices {
  constructor() {
    // make devices an object where the key is the device_guid
    this.devices = {}
  }
  
  reset() {
    console.log('VideonDevices reset')
    
    // invalidate device_guids
    for (var device of Object.values(this.devices)) {
      console.log('VideonDevices reset invalidating', device.device_guid)
      device.delete()
    }
    
    // reset cache
    this.devices = {}
  }
  
  invalidateDevice(device_guid) {
    this.devices[device_guid].delete
    Vue.delete(this.devices[device_guid])
  }
  
  deviceBySerial(serial_number) {
    var device = Object.values(this.devices).find(x => x.serial_number === serial_number)
    if (device) {
      return device
    }
    
    return false
  }
  
  async fetchDeviceAttributes(device_guid) {
    try {
      let response = await Vue.axios.get('/devices/' + device_guid)
      console.log('VideonDevices ' + device_guid + ' fetchDeviceAttributes response', response)
      
      return response.data.device
    } catch (error) {
      console.log('VideonDevices ' + device_guid + ' fetchDeviceAttributes error', Vue.helpers.parseError(error))
      
      return false
    }
  }
  
  getDevice(device_guid, device_attributes = false) {
    if (!device_guid) {
      console.log('VideonDevices getDevice missing device_guid', device_guid, device_attributes)
      return false
    }
    
    if (this.devices[device_guid]) {
      var device = this.devices[device_guid]
      if (!device.org_guid && device_attributes.org_guid) {
        device.org_guid = device_attributes.org_guid
      }
      if (!device.org_name && device_attributes.org_name) {
        device.org_name = device_attributes.org_name
      }
      
      //console.log('VideonDevices ' + device_guid + ' getDevice returning cached device', device)
      
      return device
    }
    
    console.log('VideonDevices ' + device_guid + ' getDevice creating new device instance')
    
    // insert placeholder device
    var proxyDevice = Vue.observable(new ProxyDevice(device_guid, device_attributes))
    
    this.fetchDeviceAttributes(device_guid).then((device_attributes) => {
      // no product name or is an encoder
      if (!device_attributes.product_name || EncoderProductNames.includes(device_attributes.product_name)) {
        device = Vue.observable(new VideonEncoder(device_guid, device_attributes))
        
      // decoder
      } else if (DecoderProductNames.includes(device_attributes.product_name)) {
        device = Vue.observable(new VideonDecoder(device_guid, device_attributes))
        
      // unknown product_name
      } else {
        console.log('VideonDevices ' + device_guid + ' getDevice unknown product_name', device_guid, device_attributes)
        device = Vue.observable(new UnknownDevice(device_guid, device_attributes))
      }
      
      proxyDevice.setDevice(device)
      
      console.log('VideonDevices ' + device_guid + ' getDevice updating device instance', device)
      
      this.devices[device_guid] = device
    })
    
    this.devices[device_guid] = proxyDevice
    
    console.log('VideonDevices ' + device_guid + ' getDevice returning proxy device', proxyDevice)
    
    return proxyDevice
  }
}